import React, { useRef , useState} from "react";
import { Form, Field } from "react-final-form";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
// import api from '../../api';
import { Toast } from "primereact/toast";
import { instance } from "../../api";
import './nousContacter.css'
import FileUploader from "./FileUploader";
import "./FileUploader.css"
// import { FileField } from 'react-final-form-file-field';
// import { FileUpload } from 'primereact/fileupload';

export default function NousContacter({ setDialog }) {
  const toastAdd = useRef(null);
  const [file, setFile] = useState(null); // Keep track of the file in parent form


  const onSubmit = (data) => {
    console.log("data", data);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("email", data.email);
    formData.append("message", data.message);
    formData.append("nom", data.nom);
    formData.append("objet", data.objet);
    formData.append("tel", data.tel);

    instance.post(`/api/utilisateurs/home/formulaire`, formData).then(() => {
      toastAdd.current.show({
        severity: "success",
        summary: "Succès",
        detail: "Votre demande a été envoyé avec succès  ",
        life: 2000,
      });
      setTimeout(() => {
        setDialog(false);
      }, 2000);
    });
  };
  const validate = (data) => {
    let errors = {};
    if (!data.nom) {
      errors.nom = " Prénom et nom requis.";
    }
    if (!data.objet) {
      errors.objet = "Objet requis.";
    }
    if (!data.message) {
      errors.message = "Message requis.";
    }

    // Case when email is provided but phone is missing
  {/*if (!data.tel) {
    errors.tel = "Téléphone requis.";
  }

  // Case when phone is provided but email is missing
  if (!data.email) {
    errors.email = "Adresse mail requise.";
  }*/}

  // Validate email only if provided
  if (data.email) {
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
      errors.email = "Adresse mail invalide.";
    }
  }

  // Validate phone number only if provided
  {/*if (data.tel) {
    if (!/^[+]*[0-9\b .-_/-]{9,40}$/.test(data.tel)) {
      errors.tel = "Téléphone invalide.";
    }
  }*/}

    return errors;
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return (
      isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
    );
  };

  return (
    <>
      <Toast ref={toastAdd} />

      <div className="Form_contact">
        <Form
          onSubmit={onSubmit}
          initialValues={{
            nom: "",
            objet: "",
            message: "",
            email: "",
            tel: "",
            file: "",
          }}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className="p-fluid">
              <Field
                name="nom"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputText
                        id="nom"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                      />
                      <label
                        htmlFor="nom"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Prénom NOM *
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
              <Field
                name="email"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputText
                        id="emails"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                      />
                      <label
                        htmlFor="email"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Adresse mail *
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
              <Field
                name="tel"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputText
                        id="tel"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                      />
                      <label
                        htmlFor="tel"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Téléphone 
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
              <Field
                name="objet"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputText
                        id="objet"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                      />
                      <label
                        htmlFor="objet"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Objet de la demande de contact *
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
           
              <Field
                name="message"
                render={({ input, meta }) => (
                  <div className="p-field">
                    <span className="p-float-label p-input-icon-right">
                      <InputTextarea
                        id="message"
                        {...input}
                        className={classNames({
                          "p-invalid": isFormFieldValid(meta),
                        })}
                        rows={3}
                        cols={15}
                        autoResize={false} // Désactive le redimensionnement automatique
                        style={{ resize: "vertical", overflow: "auto" }}
                      />
                      <label
                        htmlFor="message"
                        className={classNames({
                          "p-error": isFormFieldValid(meta),
                        })}
                      >
                        Message *
                      </label>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              />
                <FileUploader
                onFileChange={(selectedFile) => setFile(selectedFile)}
                label="Joindre un fichier"
                maxSize={20} // 20 MB
              />
              <div className="btnContact">
                <Button type="submit" label="Envoyer" className="p-mt-2 send" />
              </div>
            </form>
          )}
        />
      </div>
    </>
  );
}
